import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { HelpQuestionId } from './help-content';
import { HelpPanelService } from './help-panel.service';

/** "How this works": sits on its own line under a field's help text, opening the help panel at that answer. A plain link, not `appButton`, so it has no side padding and starts at the field's edge. */
@Component({
  selector: 'app-help-link',
  standalone: true,
  host: { class: 'block mt-1' },
  imports: [FaIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<button type="button" class="tap-target inline-gap link-accent no-underline hover:underline align-baseline text-body font-semibold" (click)="open()">
    <fa-icon [icon]="icon" class="size-4" aria-hidden="true" />{{ label() }}
  </button>`,
})
export class HelpLinkComponent {
  private readonly _panel = inject(HelpPanelService);

  public readonly question = input.required<HelpQuestionId>();
  public readonly label = input.required<string>();

  protected readonly icon = faCircleQuestion;

  protected open(): void {
    this._panel.open(this.question());
  }
}
